import { ExpandLess, ExpandMore } from '@mui/icons-material';
import {
  Collapse,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  List as ListM,
  Tooltip,
} from '@mui/material';
import { blue, grey } from '@mui/material/colors';
import * as React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { BLUE_COLOR } from '../../../constants/ColorsConst';

const ItemDrawer = ({ item, openDrawer }) => {
  const location = useLocation();

  const [open, setOpen] = React.useState(false);

  const handleClick = () => setOpen(!open);

  function getActivo(i) {
    const lArray = location.pathname.split('/');
    const index = lArray.indexOf(i.to.replace('/', ''));

    const existe = lArray[index + 1];

    return !existe && location.pathname.includes(i.to);
  }

  const xLink = (i, t, to) => {
    const active = getActivo({ to });
    return (
      <Link
        key={t}
        to={to}
        style={{
          color: 'black',
          textDecoration: 'none',
        }}
      >
        <ListItemButton
          sx={{
            backgroundColor: active ? BLUE_COLOR : 'transparent',
            color: active ? 'white' : 'black',
            mr: openDrawer ? 0 : 1,
            borderRadius: '7px',
            '&:hover': {
              backgroundColor: active ? blue[900] : grey[300],
              color: active ? 'white' : 'black',
              fontWeight: 'bold',
            },
          }}
          dense={true}
        >
          <ListItemIcon
            sx={{
              color: active ? 'white' : 'black',
              minWidth: '40px',
            }}
          >
            <Tooltip title={t} placement="right">
              {i}
            </Tooltip>
          </ListItemIcon>
          {openDrawer && <ListItemText primary={t} />}
        </ListItemButton>
      </Link>
    );
  };

  const xCollapse = (i) => {
    const active = getActivo(i);

    return (
      <>
        <ListItemButton
          onClick={handleClick}
          dense={true}
          sx={{
            backgroundColor: active ? '#e6e6e6' : 'transparent',
            borderRadius: '7px',
            mr: openDrawer ? 0 : 1,
            '&:hover': {
              backgroundColor: active ? blue[800] : grey[300],
              color: active ? 'white' : 'black',
            },
          }}
        >
          <ListItemIcon sx={{ minWidth: '40px' }}>
            <Tooltip title={i.title} placement="right">
              {i.icon}
            </Tooltip>
          </ListItemIcon>
          {openDrawer && (
            <>
              <ListItemText primary={i.title} />
              {open ? <ExpandLess /> : <ExpandMore />}
            </>
          )}
        </ListItemButton>
        <Collapse in={open} timeout="auto" unmountOnExit>
          <ListM component="div" disablePadding sx={{ ml: openDrawer ? 1 : 0 }}>
            {i.vistas.map((route) => {
              return route ? xLink(route.icon, route.title, route.to) : null;
            })}
          </ListM>
        </Collapse>
      </>
    );
  };

  return item.vistas && item.vistas.length > 0
    ? xCollapse(item)
    : xLink(item.icon, item.title, item.to);
};

export default ItemDrawer;
